import { toast } from 'react-toastify';

const showError = (errMessage: string, id: string) => {
  toast.error(errMessage, {
    position: 'bottom-right',
    toastId: id,
    autoClose: 3000,
    closeOnClick: true
  });
};

const throwErrorMessage = (errorCode: number, action: any, errMessage: string) => {
  console.warn(`Type: ${action.type}`);
  console.warn(`We got a rejected action in API! (ERROR CODE ${errorCode}) - ${action.meta.arg.endpointName}`);
  console.warn(action.payload);
  showError(errMessage ?? `Error code: ${errorCode}`, `${action.type}-${errorCode}-${action.meta.requestId}`);
};

export { throwErrorMessage };
